import React, { useMemo } from 'react';
import { useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  IPieChartPanel,
  IWorkspaceAlarmsPanel,
} from '../../../../../../../../theme/ui/Dashboard/Dashboard.model';
import useAlarmsByWorkspace from '../../../../../../../../redux/alarm/hooks/useAlarmsByWorkspace';
import PieChartPanel from '../../../../../../../../theme/ui/Dashboard/PieChartPanel/PieChartPanel';
interface WorkspaceAlarmPanelProps {
  panel: IWorkspaceAlarmsPanel;
}
function AlarmWorkspacePanel(props: WorkspaceAlarmPanelProps) {
  const theme = useTheme();
  const { t } = useTranslation();
  const { allAlarms, isLoading: isLoadingAlarmsData } = useAlarmsByWorkspace(
    props.panel.workspaceId
  );

  const alarmsDisconnection = useMemo(
    () => allAlarms?.filter((alarm) => alarm?.event !== '_disconn'),
    [allAlarms]
  );

  const nAlarmDevice =
    allAlarms &&
    alarmsDisconnection &&
    allAlarms.length - alarmsDisconnection?.length;
  const nAlarmDisconnection = alarmsDisconnection?.length;

  const pieChartPanel: IPieChartPanel = {
    ...props.panel,
    type: 'PIE_CHART',
    loading: isLoadingAlarmsData,
    series: [
      {
        data: [
          {
            label: t('dashboard.alarms.disconnection_alarms') ?? '',
            value: nAlarmDevice ?? 0,
            color: theme.palette.warning.main,
          },
          {
            label: t('dashboard.alarms.device_alarms') ?? '',
            value: nAlarmDisconnection ?? 0,
            color: theme.palette.error.main,
          },
        ],
        innerRadius: '70%',
        outerRadius: '100%',
      },
    ],
  };
  return <PieChartPanel panel={pieChartPanel} />;
}

export default AlarmWorkspacePanel;
